// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7cb2c779","75":"85db4f23","108":"0d06f88b","116":"12c3c589","204":"4fd6cb83","274":"64056100","379":"40e24e76","430":"d3778556","447":"0e17ce2e","453":"99320d0e","589":"81aa245c","722":"c2c2d72a","758":"e6d87e8a","835":"fb538ab6"}[chunkId] + ".chunk.js";
};